import routes from '@/modules/real-estate-register/real-estate-register-routes';
import store from '@/modules/real-estate-register/real-estate-register-store';

export default {
    routes,
    store,
};